import { useMemo } from "react";

/**
 * The real dimensions are only used in a few places, so it's easier to pass around these mocked dimensions that fill in spacing
 */
const useAdjustedDimensions = ({
	mainItemDimensions,
	carouselItemDimensions,
}: {
	mainItemDimensions: {
		width: number;
		height: number;
		spacing?: number;
	};
	carouselItemDimensions: {
		width: number;
		height: number;
		spacing?: number;
	};
}) => {
	const adjustedMainItemDimensions = useMemo(
		() => ({
			width: mainItemDimensions.width + (mainItemDimensions.spacing ?? 0),
			height: mainItemDimensions.height,
		}),
		[mainItemDimensions],
	);
	const adjustedCarouselItemDimensions = useMemo(
		() => ({
			width: carouselItemDimensions.width + (carouselItemDimensions.spacing ?? 0),
			height: carouselItemDimensions.height,
		}),
		[carouselItemDimensions],
	);

	return {
		adjustedMainItemDimensions,
		adjustedCarouselItemDimensions,
	};
};
export default useAdjustedDimensions;
